export const VETA_CENTER_DATE_TIME_FORMAT = 'MMM D, YYYY, h:mm A';
